import { css } from '@emotion/core';
import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid';
import { Magnetic } from "../../styles";
import { miFormControlCore } from "../inputs/styles/Input.styles";
import { Button } from "../button";
export const StyledSearchBoxInput = styled('input') `
	${miFormControlCore}
	font-size: ${Magnetic.baseFontSize};
	border-top-right-radius: ${(props) => !props.isLiveSearch && Magnetic.searchFieldBorderTopRightRadius};
	border-bottom-right-radius:${(props) => !props.isLiveSearch && Magnetic.searchFieldBorderBottomRightRadius}; 
	flex: auto;
	&:focus {
		box-shadow: ${(props) => !props.isLiveSearch && Magnetic.searchFieldBoxShadowFocus};
	}	
`;
export const StyledSearchBoxInputCss = css `
	padding-left: ${Magnetic.spacer32};
`;
export const StyledSearchBoxIcon = styled('div') `
	position: absolute;
	padding: ${Magnetic.spacer12};
	color: ${Magnetic.colorBrand50};
	font-size: ${Magnetic.baseFontSize};
	line-height: 12px;
`;
export const StyledSearchButton = styled(Button) `
	background-color: ${Magnetic.formControlCoreBackgroundColor};
`;
export const StyledCrossIcon = styled(Button) `
	display: ${(props) => (props.isHideCancelIcon ? 'none' : 'block')};
	position: absolute;
	top: 8px;
	right: 8px;
	color: ${Magnetic.colorNeutral60};
	font-size: ${Magnetic.fontSize12};
	height: 20px;
	width: 20px;
	padding: 0px;
	&:hover {
		background-color: ${Magnetic.buttonFlatBackgroundColorHover};
	}
	&:active {
		background-color: ${Magnetic.buttonFlatBackgroundColorActive};
	}
`;
export const SearchInputError = css `
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.validationErrorColor};
	box-shadow: inset 0 0 0 ${Magnetic.baseBorderWidth} ${Magnetic.validationErrorColor};
`;
export const StyledSearchBoxContainer = styled(Grid, {
    shouldForwardProp: prop => prop !== 'shouldShowCrossIcon'
}) `
	position: ${(props) => props.shouldShowCrossIcon && 'relative'};
`;
//# sourceMappingURL=SearchBox.style.js.map